import {
  ContactPhoneRounded,
  CreditCardRounded,
  DeliveryDiningRounded,
  ErrorRounded,
  ExpandMoreRounded,
  ListAltRounded,
  PaidRounded,
  PersonRounded,
  PixRounded,
  PointOfSaleRounded,
  QrCodeRounded,
  QuestionAnswerRounded,
  ReceiptLongRounded,
  ScheduleRounded,
  SummarizeRounded,
  TakeoutDiningRounded,
} from "@mui/icons-material";
import { Box, Chip, Collapse, IconButton } from "@mui/material";
import React from "react";
import { GreyPallet } from "../../config/styles";
import ExpandMore from "../ExpandMore";
import MainText from "../MainText";

export default function CafeteriaOrder() {
  const [showContent, setShowContent] = React.useState(false);

  return (
    <Box borderRadius={"10px"} bgcolor={GreyPallet.LightGhost} px={2} py={1} mb={2}>
      <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} mb={2}>
        <Box>
          <Box display={"flex"} gap={1} justifyContent={"start"} alignItems={"center"}>
            <ScheduleRounded fontSize="small" sx={{ color: GreyPallet.Regular }} />
            <MainText size="small" color="regular">
              2024/02/06 20:35
            </MainText>
          </Box>
          <Box display={"flex"} gap={1} justifyContent={"start"} alignItems={"center"}>
            <PointOfSaleRounded fontSize="small" sx={{ color: GreyPallet.Regular }} />
            <MainText size="body" color="regular">
              R$ 45,07
            </MainText>
          </Box>
        </Box>

        <Box
          display={"flex"}
          justifyContent={"end"}
          flexDirection={"column"}
          gap={1}
          maxWidth={"60%"}
        >
          <Box display={"flex"} justifyContent={"end"}>
            {/* <Chip
            label="Criado"
            color="error"
            onDelete={() => {}}
            icon={<CallReceivedRounded />}
               deleteIcon={<ExpandMoreRounded />}
          /> */}
            {/* <Chip
            label="Preparando"
            color="info"
            onDelete={() => {}}
            icon={<DinnerDiningRounded />}
               deleteIcon={<ExpandMoreRounded />}
          /> */}

            <Chip
              label="Pronto p/ Retirada"
              color="warning"
              onDelete={() => {}}
              icon={<TakeoutDiningRounded />}
              deleteIcon={<ExpandMoreRounded />}
            />
            {/* <Chip
            label="Saiu p/ Entrega"
            color="warning"
            onDelete={() => {}}
            icon={<DeliveryDiningRounded />}
            deleteIcon={<ExpandMoreRounded />}
            /> */}
            {/* <Chip
            label="Entregue"
            color="success"
            onClick={() => {}}
            onDelete={() => {}}
            icon={<CheckCircleRounded />}
            deleteIcon={<ExpandMoreRounded />}
            /> */}
          </Box>

          {/*  */}

          <Box display={"flex"} justifyContent={"end"}>
            {/* <Chip label="Aguardando Pagamento Coisa Coisa" color="default" icon={<PaidRounded />} /> */}
            {/* <Chip label="Pagamento Recebido" color="success" icon={<PaidRounded />} /> */}
            {/* <Chip label="Retornado" color="default" icon={<PaidRounded />} /> */}
            {/* <Chip label="Erro no Pagamento" color="error" icon={<MoneyOffCsredRounded />} /> */}
          </Box>
        </Box>
      </Box>

      <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"}>
        <Box>
          <Box display={"flex"} gap={1} justifyContent={"start"} alignItems={"center"}>
            <ReceiptLongRounded fontSize="small" sx={{ color: GreyPallet.Black }} />
            <MainText>RP-1245</MainText>
          </Box>

          <Box display={"flex"} gap={1} justifyContent={"start"} alignItems={"center"}>
            <PersonRounded fontSize="small" sx={{ color: GreyPallet.Black }} />
            <MainText>Fulano de Tal</MainText>
          </Box>
        </Box>

        <ExpandMore
          expand={showContent}
          onClick={() => setShowContent(!showContent)}
          aria-expanded={showContent}
        >
          <ExpandMoreRounded />
        </ExpandMore>
      </Box>

      <Box
        mt={2}
        p={1}
        gap={1}
        borderRadius={"10px"}
        bgcolor={GreyPallet.WhiteGhost}
        display={"flex"}
        justifyContent={"start"}
        alignItems={"center"}
      >
        <SummarizeRounded />
        <Box>
          <MainText size="small" color="black">
            Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora possimus necessitatibus
            recusandae voluptates omnis harum.
          </MainText>
          <MainText size="tiny" color="regular">
            *Essa anotação não é visível para o cliente
          </MainText>
        </Box>
      </Box>

      <Collapse in={showContent} timeout="auto" unmountOnExit={true} sx={{ overflow: "hidden" }}>
        <Box>
          {/* Contact */}
          <Box mt={2}>
            <Box display={"flex"} gap={1} justifyContent={"start"} alignItems={"center"}>
              <ContactPhoneRounded fontSize="small" sx={{ color: GreyPallet.Regular }} />
              <MainText size="caption" color="regular">
                Contato:
              </MainText>
            </Box>

            <Box
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
              mt={1}
              borderRadius={"10px"}
              p={1}
              bgcolor={GreyPallet.WhiteGhost}
            >
              <Box>
                <MainText>fulanodetal@email.com</MainText>
                <MainText>(84) 9 9874-5878</MainText>
              </Box>
              <Box>
                <IconButton sx={{ backgroundColor: GreyPallet.LightGhost }}>
                  <QuestionAnswerRounded />
                </IconButton>
              </Box>
            </Box>
          </Box>

          {/* Order */}
          <Box mt={2}>
            <Box display={"flex"} gap={1} justifyContent={"start"} alignItems={"center"}>
              <ListAltRounded fontSize="small" sx={{ color: GreyPallet.Regular }} />
              <MainText size="caption" color="regular">
                Pedido:
              </MainText>
            </Box>

            <Box
              mt={2}
              p={1}
              gap={1}
              borderRadius={"10px"}
              bgcolor={GreyPallet.WhiteGhost}
              display={"flex"}
              justifyContent={"start"}
              alignItems={"center"}
            >
              <ErrorRounded />
              <Box>
                <MainText size="small" color="regular">
                  Observação do Cliente:
                </MainText>
                <MainText size="small" color="black">
                  Lorem ipsum dolor sit amet consectetur adipisicing elit. Tempora possimus
                  necessitatibus recusandae voluptates omnis harum.
                </MainText>
              </Box>
            </Box>

            <Box sx={{ textAlign: "right" }}>
              <Box mt={1} borderRadius={"10px"} p={1} bgcolor={GreyPallet.WhiteGhost}>
                <MainText size="body" color="black">
                  Pão com Frango Cremoso
                </MainText>
                <Box sx={{ textAlign: "right" }}>
                  <MainText size="caption" color="black">
                    <span style={{ whiteSpace: "nowrap" }}>x2 R$ 3,50</span>
                  </MainText>
                </Box>
              </Box>

              <Box mt={1} borderRadius={"10px"} p={1} bgcolor={GreyPallet.WhiteGhost}>
                <MainText size="body" color="black">
                  Marmita P
                </MainText>
                <Box mr={1}>
                  <MainText size="tiny" color="regular">
                    Proteínas:
                  </MainText>
                </Box>
                <MainText size="caption" color="regular">
                  Frango ao Forno x1
                </MainText>
                <MainText size="caption" color="regular">
                  Linguiça (linguiça de frango) x1
                </MainText>
                <Box mr={1}>
                  <MainText size="tiny" color="regular">
                    Acompanhamentos:
                  </MainText>
                </Box>
                <MainText size="caption" color="regular">
                  Feijão Preto x1
                </MainText>
                <MainText size="caption" color="regular">
                  Erroz refogado x2
                </MainText>
                <MainText size="caption" color="regular">
                  Batata doce x1
                </MainText>
                <Box mr={1}>
                  <MainText size="tiny" color="regular">
                    Saladas:
                  </MainText>
                </Box>
                <MainText size="caption" color="regular">
                  Salada verde x1
                </MainText>

                <Box sx={{ textAlign: "right" }}>
                  <MainText size="caption" color="black">
                    <span style={{ whiteSpace: "nowrap" }}>x1 R$ 3,50</span>
                  </MainText>
                </Box>
              </Box>

              {/* <Divider sx={{ my: 1 }} /> */}

              <Box sx={{ textAlign: "right" }} mt={1}>
                <MainText>Total: R$ 45,00</MainText>
              </Box>
            </Box>
          </Box>

          {/* Delivery */}
          <Box mt={2}>
            <Box display={"flex"} gap={1} justifyContent={"start"} alignItems={"center"}>
              <DeliveryDiningRounded fontSize="small" sx={{ color: GreyPallet.Regular }} />
              <MainText size="caption" color="regular">
                Entrega:
              </MainText>
            </Box>

            <Box
              display={"flex"}
              mt={1}
              borderRadius={"10px"}
              p={1}
              bgcolor={GreyPallet.WhiteGhost}
            >
              <Box>
                <MainText size="small" color="regular">
                  Rua:
                </MainText>
                <MainText>Rua das Mansoes 3555</MainText>

                <MainText size="small" color="regular">
                  Bairro:
                </MainText>
                <MainText>Candelária, Natal</MainText>

                <MainText size="small" color="regular">
                  Complemento:
                </MainText>
                <MainText>Apartamento 500</MainText>
              </Box>
            </Box>
          </Box>

          {/* Payment */}
          <Box mt={2}>
            <Box display={"flex"} gap={1} justifyContent={"start"} alignItems={"center"}>
              <PaidRounded fontSize="small" sx={{ color: GreyPallet.Regular }} />
              <MainText size="caption" color="regular">
                Pagamento:
              </MainText>
            </Box>

            <Box
              mt={2}
              p={1}
              gap={1}
              borderRadius={"10px"}
              bgcolor={GreyPallet.WhiteGhost}
              display={"flex"}
              justifyContent={"start"}
              alignItems={"center"}
            >
              <CreditCardRounded />
              <MainText color="black">Crédito na Entrega</MainText>
            </Box>

            <Box
              mt={2}
              p={1}
              gap={1}
              borderRadius={"10px"}
              bgcolor={GreyPallet.WhiteGhost}
              display={"flex"}
              justifyContent={"start"}
              alignItems={"center"}
            >
              <PixRounded />
              <MainText color="black">Pix na Entrega</MainText>
            </Box>

            <Box
              mt={2}
              p={1}
              borderRadius={"10px"}
              bgcolor={GreyPallet.WhiteGhost}
              display={"flex"}
              justifyContent={"space-between"}
              alignItems={"center"}
            >
              <Box gap={1} display={"flex"} justifyContent={"start"} alignItems={"center"}>
                <PixRounded />
                <MainText color="black">Pix via Aplicativo</MainText>
              </Box>
              <IconButton sx={{ backgroundColor: GreyPallet.LightGhost }}>
                <QrCodeRounded />
              </IconButton>
            </Box>
          </Box>
        </Box>
      </Collapse>
    </Box>
  );
}
